import * as Yup from "yup";

// Common field schemas
const commonUserFields = {
  firstName: Yup.string().min(3, "First name must be at least 3 characters").required("First name is required"),
  middleName: Yup.string().optional(),
  lastName: Yup.string().min(3, "Last name must be at least 3 characters").required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string()
    .matches(/^\d{10}$/, "Phone must be exactly 10 digits")
    .required("Phone is required"),
  password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Confirm Password is required"),
  street: Yup.string().min(3, "Street must be at least 3 characters").optional(),
  city: Yup.string().min(2, "City must be at least 2 characters").optional(),
  state: Yup.string().min(2, "State must be at least 2 characters").optional(),
  zipcode: Yup.string().matches(/^\d{5}(-\d{4})?$/, "Zipcode must be valid (e.g., 12345 or 12345-6789)").optional(),
};

// Common initial values
const commonInitialValues = {
  firstName: "",
  middleName: "",
  lastName: "",
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",
  street: "",
  city: "",
  state: "",
  zipcode: "",
};

// Business
export const BusinessSchema = Yup.object().shape({
  ownerFirstName: Yup.string().min(1, "Owner First Name is required").required("Owner First Name is required"),
  ownerMiddleName: Yup.string().optional(),
  ownerLastName: Yup.string().min(1, "Owner Last Name is required").required("Owner Last Name is required"),
  name: Yup.string().max(255).required("Business name is required"),
  ein: Yup.string().matches(/^\d{9}$/, "EIN must be a 9-digit number").required("EIN is required"),
  synonyms: Yup.array().of(Yup.string().max(255)).max(5, "Maximum 5 synonyms allowed"),
  phone: commonUserFields.phone,
  email: commonUserFields.email,
  website: Yup.string().url("Invalid URL").max(255),
  password: commonUserFields.password,
  confirmPassword: commonUserFields.confirmPassword,
  street: commonUserFields.street,
  city: commonUserFields.city,
  state: commonUserFields.state,
  zipcode: commonUserFields.zipcode,
});

export const businessInitialValues = {
  ownerFirstName: "",
  ownerMiddleName: "",
  ownerLastName: "",
  name: "",
  ein: "",
  synonyms: [""],
  phone: "",
  email: "",
  website: "",
  password: "",
  confirmPassword: "",
  street: "",
  city: "",
  state: "",
  zipcode: "",
};

// Login
export const LoginSchema = Yup.object().shape({
  email: commonUserFields.email,
  password: commonUserFields.password,
});

export const loginInitialValues = {
  email: "",
  password: "",
};

// Forgot Password Email
export const ForgotPasswordEmailSchema = Yup.object().shape({
  email: commonUserFields.email,
});

export const forgotPasswordEmailInitialValues = {
  email: "",
};

// OTP Verification
export const OTPSchema = Yup.object().shape({
  otp: Yup.string().matches(/^\d{4}$/, "OTP must be exactly 4 digits").required("OTP is required"),
});

export const otpInitialValues = {
  otp: "",
};

// Change Password
export const ChangePasswordSchema = Yup.object().shape({
  newPassword: commonUserFields.password,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Passwords do not match")
    .required("Confirm Password is required"),
});

export const changePasswordInitialValues = {
  newPassword: "",
  confirmPassword: "",
};

// CoOwner (has "name" with min 3 chars)
export const CoOwnerSchema = Yup.object().shape({
  ...commonUserFields,
});

export const coOwnerInitialValues = {
  ...commonInitialValues,
};

// Employee
export const EmployeeSchema = Yup.object().shape({
  ...commonUserFields,
});

export const employeeInitialValues = {
  ...commonInitialValues,
};

// Customer
export const CustomerSchema = Yup.object().shape({
  ...commonUserFields,
});

export const customerInitialValues = {
  ...commonInitialValues,
};

// Banker
export const BankerSchema = Yup.object().shape({
  ...commonUserFields,
});

export const bankerInitialValues = {
  ...commonInitialValues,
};
